/* eslint-disable import/extensions */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */

import { useState } from 'react';

import { useAccount } from 'wagmi';

import createChat from '@/api/chatApi/createChat';
import { Spinner } from '@/components/Spinner/Spinner';
import { isTokenValid } from '@/utils/index';
import useChatScroll from '@/utils/useChatScroll';
import { IChatProps } from 'interfaces/ChatTab/chatTab';
import MainLogo from 'public/assets/mainLogo.png';

import ChatConnectWalletScreen from './ChatConnectWalletScreen';
import ChatInput from './ChatInput';
import UserMessage from './UserMessage';
import UserRecievedText from './UserRecievedText';

const ChatTab = ({
  uuId,
  userMessages,
  ipfsPreviewHash,
  setUserMessages,
  setSignalNewMessage,
  isLoading,
}: IChatProps) => {
  const chatArea = useChatScroll();
  const { data: signer } = useAccount();
  const [isUserLoggedIn, setUserLoggedIn] = useState(
    isTokenValid(localStorage.getItem('token'), signer?.address)
  );

  return (
    <div className="grid grid-rows-6 h-full p-4">
      {isUserLoggedIn ? (
        <>
          <div
            ref={chatArea}
            className="row-span-6 relative items-end grid overflow-y-auto"
          >
            {isLoading ? (
              <div className="absolute w-full top-0">
                <Spinner />
              </div>
            ) : userMessages.length === 0 ? (
              <div className="h-full flex items-center justify-center">
                <div>
                  <div className="flex justify-center items-center mb-4 ">
                    <img
                      src={MainLogo.src}
                      alt="fileverse"
                      className="rounded-full w-20"
                    />
                  </div>
                  <p className="text-center">
                    Encrypted chat room for addresses with file access
                  </p>
                </div>
              </div>
            ) : (
              <div className="">
                {userMessages.map((chat: any, index: any) => {
                  if (chat.by === signer?.address.toLowerCase()) {
                    return (
                      <div key={index}>
                        <UserMessage
                          day={chat?.createdAt}
                          message={chat.text}
                        />
                      </div>
                    );
                  }
                  return (
                    <div key={index}>
                      <UserRecievedText
                        key={index}
                        address={chat.by}
                        text={chat.text}
                        day={chat.createdAt}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <ChatInput
            createChat={createChat}
            setUserMessages={setUserMessages}
            setSignalNewMessage={setSignalNewMessage}
            uuId={uuId}
            ipfsPreviewHash={ipfsPreviewHash}
          />
        </>
      ) : (
        <ChatConnectWalletScreen setUserLoggedIn={setUserLoggedIn} />
      )}
    </div>
  );
};

export default ChatTab;
